






























import Vue, { PropOptions } from 'vue'
import DxDataGrid from 'devextreme-vue/data-grid'
import { mapState, mapGetters, mapActions } from 'vuex'
import { sort } from '../utils'
import { dxDataGridColumn } from 'devextreme/ui/data_grid'

export default Vue.extend({
  components: { DxDataGrid },
  inheritAttrs: false,
  props: {
    // required DxGrid props
    keyExpr: {type: String, required: true},
    columns: {type: Array, required: true} as PropOptions<dxDataGridColumn[]>,
    // custom props
    entries: {type: Array, required: true},
    singular: {type: String, default: 'item'},
    plural: {type: String, default: 'items'},
  },
  data() {
    return {
      focusedRowEnabled: true,
    }
  },
  computed: {
    ...mapState(['keyField', 'filter', 'focusedEntry']),
    ...mapGetters(['fieldTypes', 'fieldLevels', 'entriesCount']),
    filterValue: { // synchronize filterValue to the store.filter
      get(): any { return this.filter },
      set(filter: any) { this.setFilter({filter}) }
    },
    focusedRowKey: { // synchronize filterValue to the store.filter
      get(): any { return this.focusedEntry?.[this.keyField] },
      set(key: any) { this.setFocusedEntry({key}) }
    },
    config() {
      // eslint-disable-next-line prefer-const
      for (const column of this.columns) {
        const field = column.dataField
        if (typeof field !== 'undefined' && this.fieldTypes.get(field) === 'array') {
          column.calculateDisplayValue = (rowData: any) => sort(rowData[field]).join(' / ')
          column.lookup = { dataSource: this.fieldLevels.get(field) }
          column.calculateFilterExpression = (filterValue: any, selectedFilterOperation: string) => {
            console.log(field, selectedFilterOperation, filterValue)
            switch (selectedFilterOperation) {
              case '=':
                if (filterValue == null)
                  return (rowData: any) => ((rowData[field] as Array<string>).length == 0)
                else
                  return (rowData: any) => ((rowData[field] as Array<string>).includes(filterValue))
              case '<>':
                console.log(filterValue == null)
                if (filterValue == null)
                  return (rowData: any) => ((rowData[field] as Array<string>).length > 0) // for some reason this filter is sometimes ignored (executed, but not applied)
                else
                  return (rowData: any) => ( ! (rowData[field] as Array<string>).includes(filterValue))
              case 'contains':
                return (rowData: any) => ((rowData[field] as Array<string>).includes(filterValue))
              case 'notcontains':
                return (rowData: any) => ( ! (rowData[field] as Array<string>).includes(filterValue))
              default:
                console.error(`${selectedFilterOperation} is not supported in ${arguments.callee.name}`)
                return () => false
            }
          }
        }
      }
      return {
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        cellHintEnabled: true,
        columnAutoWidth: true,
        filterSyncEnabled: true,
        autoNavigateToFocusedRow: true,
        hoverStateEnabled: true,
        dataSource: this.entries,
        keyExpr: this.keyExpr,
        columnChooser: {enabled: true, mode: 'select'},
        filterPanel: {visible: true},
        scrolling: {mode: 'virtual', useNative: true},
        sorting: {mode: 'multiple'},
        headerFilter: {visible: true, allowSearch: true},
        columns: this.columns,
        summary: {
          totalItems: [
            { name: "filteredKeys", summaryType: "custom", column: this.keyExpr, customizeText: ({value: filteredKeys}: {value: Set<string>}) => `${filteredKeys.size} ${ filteredKeys.size > 1 ? this.plural : this.singular }${filteredKeys.size < this.entriesCount ? ` (filtered from ${this.entriesCount})` : ''}` },
          ],
          calculateCustomSummary: (options: {name: string; summaryProcess: string; value: string; totalValue: Set<string>}) => {
            if(options.name == "filteredKeys") {
              if (options.summaryProcess == 'start')
                options.totalValue = new Set<string>()
              else if (options.summaryProcess == 'calculate')
                options.totalValue.add(options.value)
              else if (options.summaryProcess == 'finalize')
                this.selectEntries({keys: options.totalValue})
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['selectEntries', 'setFilter', 'setFocusedEntry']),
  },
})
